import {
  AppInterface,
  ConferenceAppSetupResponse,
  ConfigureSubaccountResponse,
  LocationVarKey,
  LocationsForNumberPurchaseResponse,
  NumberPlatform,
  NumberPlatformResponse,
  PurchaseNumberRequest,
  PurchaseNumberResponse,
  SearchNumbersRequest,
  SearchNumbersResponse,
  SwitchPlatformResponse,
  TwilioSetupInterface,
  TwilioSubaccountsResponse
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Twilio/Setup/TwilioSetup.Controller.ts
export class TwilioSetupAPI {
  static async getCurrentTwilioSetup(orgId: number): Promise<TwilioSetupInterface> {
    return APIService.Server.get<TwilioSetupInterface>(`/twilio-setup/org/${orgId}/current`);
  }
  static async setupTwilio(orgId: number): Promise<AppInterface> {
    return APIService.Server.post<AppInterface>(`/twilio-setup/org/${orgId}/setup`);
  }
  static async listSubaccounts(orgId: number): Promise<TwilioSubaccountsResponse> {
    return APIService.Server.get<TwilioSubaccountsResponse>(`/twilio-setup/org/${orgId}/subaccounts`);
  }
  static async configureSubaccount(orgId: number, subaccountSid: string): Promise<ConfigureSubaccountResponse> {
    return APIService.Server.post<ConfigureSubaccountResponse>(`/twilio-setup/org/${orgId}/configure-subaccount`, { subaccountSid });
  }
  /** Set up the bot's conference TwiML App in a number's subaccount and stamp the app row (ENG-3468). */
  static async setupConferenceApp(orgId: number, appId: number, applyToSiblings: boolean): Promise<ConferenceAppSetupResponse> {
    return APIService.Server.post<ConferenceAppSetupResponse>(`/twilio-setup/org/${orgId}/apps/${appId}/conference-app`, { applyToSiblings });
  }
  static async getNumberPlatform(orgId: number, appId: number): Promise<NumberPlatformResponse> {
    return APIService.Server.get<NumberPlatformResponse>(`/twilio-setup/org/${orgId}/apps/${appId}/platform`);
  }
  static async switchNumberPlatform(
    orgId: number,
    appId: number,
    platform: NumberPlatform,
    applyToSiblings: boolean
  ): Promise<SwitchPlatformResponse> {
    return APIService.Server.post<SwitchPlatformResponse>(`/twilio-setup/org/${orgId}/apps/${appId}/platform`, { platform, applyToSiblings });
  }
  static async getLocationsForNumberPurchase(orgId: number): Promise<LocationsForNumberPurchaseResponse> {
    return APIService.Server.get<LocationsForNumberPurchaseResponse>(`/twilio-setup/org/${orgId}/locations`);
  }
  static async searchAvailableNumbers(orgId: number, request: SearchNumbersRequest): Promise<SearchNumbersResponse> {
    return APIService.Server.post<SearchNumbersResponse>(`/twilio-setup/org/${orgId}/search-numbers`, request);
  }
  static async purchaseNumber(orgId: number, request: PurchaseNumberRequest): Promise<PurchaseNumberResponse> {
    return APIService.Server.post<PurchaseNumberResponse>(`/twilio-setup/org/${orgId}/purchase-number`, request);
  }
}
